const MEASUREMENT_ID = process.env.REACT_APP_WALLET_GA_MEASUREMENT_ID;
let configured = false;

function safeGtag(...args) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag(...args);
  } catch (_) {}
}

// Call once on WalletPage mount. Registers the wallet GA property on the
// existing gtag instance (already loaded by react-ga4 in App.js), then sends
// a single page_view scoped to just this property via send_to. We skip the
// automatic send_page_view so the site-wide GAListener (scoped to the main
// property only) stays the sole source of page_view hits everywhere else.
// No-ops in development or when the env var is absent.
export function initWalletAnalytics() {
  if (configured || !MEASUREMENT_ID || process.env.NODE_ENV !== "production") return;
  safeGtag("config", MEASUREMENT_ID, { send_page_view: false });
  safeGtag("event", "page_view", { send_to: MEASUREMENT_ID });
  configured = true;
}

export function trackEvent(eventName, params = {}) {
  if (!MEASUREMENT_ID) return;
  safeGtag("event", eventName, { send_to: MEASUREMENT_ID, ...params });
}
